// extracted by mini-css-extract-plugin
export var backdropBlur = "_l8-0";
export var contentCard = "_l8-5";
export var frame = "_l8-2";
export var image = "_l8-4";
export var imagePane = "_l8-3";
export var modal = "_l8-1";